module.exports = __webpack_public_path__ + "img/icon_redpag_firework.169e83aa.png";